import _logo from './logo.svg';
import _logoFull from './logo_full.svg';
import _Contraband from './Contraband';
import _Insurance from './Insurance';

export const LOGO = _logo;
export const LOGO_FULL = _logoFull;
export const Contraband = _Contraband;
export const Insurance = _Insurance;

export { SHIPPING_SERVICES } from './shipping_services';

export const TELEGRAM_BOT_API_KEY = '1181536742:AAEXnbgSzmEtO8eLmcZ6PTBJZHf2Zdt-xF8';
export const TELEGRAM_BOT_CHAT_ID = -433757173;
export const TELEGRAM_BOT_URI = `https://api.telegram.org/bot${TELEGRAM_BOT_API_KEY}/sendMessage`;

export const COMPANY_FULL_NAME = '川越国际集运';
export const COMPANY_SHORT_NAME = '川越';
export const COMPANY_WECHAT_ID = 'A197910200118';
export const COMPANY_WORKING_HOURS = '正常工作时间为周一至周六 8:30-20:30';
export const COMPANY_PACKING_DAYS_GUARANTEE = 3;
export const WAREHOUSE_ADDRESS = '江苏省苏州市吴江区黎里镇汾湖村川越国际货运代理有限公司小幻';
export const WAREHOUSE_PHONE = '15216630271';
export const WAREHOUSE_ZIP_CODE = '215214';

export const COUNTRIES_SUPPORTED = {
  US: '美国',
  JP: '日本',
  CA: '加拿大',
};

export const CURRENCIES_SUPPORTED = {
  CNY: '人民币',
};

type PaymentInfoType = {
  show: boolean,
  alipay?: {
    enabled: boolean,
    account?: string,
    accountName?: string,
  },
  taobao?: {
    enabled: boolean,
    link?: string,
  },
  wechatPay?: {
    enabled: boolean,
    account?: string,
    accountName?: string,
  },
  paypal?: {
    enabled: boolean,
    account?: string,
    accountName?: string,
  },
};

export const PAYMENT_INFO: PaymentInfoType = {
  show: false,
};

export const ADMIN_LOGIN_PAGE_SHOW_LOGO = true;
export const ADMIN_LOGIN_PAGE_SHOW_COMPANY_NAME = false;
export const TICKET_SYSTEM_ENABLED = false;
export const SHOW_INSURANCE_PAGE = true;
export const EMAIL_NOTIFICATION_ENABLED = false;
export const ORDER_UPLOAD_IMAGE = false;
export const PACKAGE_UPLOAD_IMAGE = false;
export const DIRECT_ORDER_SELECT_SERVICE_ENABLED = false;
export const SHOW_SHIPPING_ROUTE_PAGE = false;
export const SHOW_CURRENCY_OPTION_IN_ORDER_PAGE = false;

export const PRICE_PER_PACKAGE = 0.12;
